import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

const Captcha = ({ onVerify, resetTrigger }) => {
  const [captchaText, setCaptchaText] = useState('');
  const [userInput, setUserInput] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  const generateCaptcha = () => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInput('');
    setIsVerified(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // Reset captcha when resetTrigger changes
  useEffect(() => {
    if (resetTrigger) {
      console.log('Resetting captcha due to authentication failure');
      generateCaptcha();
      onVerify(false);
    }
  }, [resetTrigger, onVerify]);

  const handleVerify = () => {
    const verified = userInput.toLowerCase() === captchaText.toLowerCase();
    setIsVerified(verified);
    onVerify(verified);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleVerify();
    }
  };

  // Auto-verify when input length matches captcha length
  useEffect(() => {
    if (userInput.length === captchaText.length && userInput.length > 0) {
      const verified = userInput.toLowerCase() === captchaText.toLowerCase();
      setIsVerified(verified);
      onVerify(verified);
    } else if (userInput.length > 0 && userInput.length < captchaText.length) {
      // Reset verification if user is still typing
      setIsVerified(false);
      onVerify(false);
    }
  }, [userInput, captchaText, onVerify]);

  const handleRefresh = () => {
    generateCaptcha();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        Please enter the code below:
      </Typography>
      
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2,
        p: 2,
        bgcolor: '#ffffff',
        borderRadius: 2,
        border: '2px solid #e0e0e0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'monospace',
            fontWeight: 'bold',
            letterSpacing: '0.5em',
            color: '#333',
            userSelect: 'none'
          }}
        >
          {captchaText}
        </Typography>
        <Button size="small" onClick={handleRefresh}>
          ↻
        </Button>
      </Box>

      <TextField
        fullWidth
        label="Enter CAPTCHA (Press Enter to verify)"
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        onKeyPress={handleKeyPress}
        size="small"
      />

      <Button
        variant="outlined"
        onClick={handleVerify}
        disabled={!userInput}
        size="small"
      >
        Verify CAPTCHA
      </Button>

      {userInput && (
        <Typography 
          variant="body2" 
          color={isVerified ? 'success.main' : 'error.main'}
        >
          {isVerified ? '✓ CAPTCHA verified' : '✗ CAPTCHA incorrect'}
        </Typography>
      )}
    </Box>
  );
};

export default Captcha; 